module.exports = __webpack_public_path__ + "img/s2P10.d8e7ad24.png";